import './FlatMenu.pcss';
import React from 'react';
import classnames from 'classnames';
import { isObject } from 'lodash';
import { RightOutlined } from '@ant-design/icons';

export type ItemLike = {
  id?: number | string;
  name: string;
  [key: string]: any;
};

type ActiveItem = ItemLike | number | string;

type FlatMenuProps = {
  className?: string;
  header?: string | React.ReactNode;
  activeItem: ActiveItem;
  items: ItemLike[];
  onItemSelect: (selectedItem: ItemLike) => any;
  itemClassName?: string;
  withRightArrow?: boolean;
};

type FlatMenuItemProps = {
  activeItem: ActiveItem;
  item: ItemLike;
  onItemSelect: (selectedItem: ItemLike) => any;
  className?: string;
  withRightArrow?: boolean;
};

const getActiveItemId = (activeItem: ActiveItem) => {
  if (isObject(activeItem)) {
    return (activeItem as ItemLike).id;
  }

  return activeItem;
};

const FlatMenuItem = ({
  item,
  activeItem,
  onItemSelect,
  className,
  withRightArrow,
}: FlatMenuItemProps) => {
  const activeItemId = getActiveItemId(activeItem);
  const itemClassList = classnames('flat-menu-item', className, {
    'flat-menu-item--active': item.id === activeItemId,
  });

  return (
    <div
      key={item.id}
      className={itemClassList}
      onClick={() => onItemSelect(item)}
    >
      <div className="flat-menu-item__name">{item.name}</div>
      {withRightArrow && (
        <RightOutlined className="flat-menu-item__right-arrow" />
      )}
    </div>
  );
};

const flatMenuHeader = (header?: string | React.ReactNode) => {
  const headerIsString = typeof header === 'string';

  if (header) {
    if (headerIsString) {
      return <div className="flat-menu__header">{header}</div>;
    }

    return header as React.ReactNode;
  }

  return null;
};

const FlatMenu = (props: FlatMenuProps) => {
  const {
    activeItem,
    items,
    onItemSelect,
    header,
    className,
    itemClassName,
    withRightArrow,
  } = props;
  const classList = classnames('flat-menu', className);

  return (
    <div className={classList}>
      {flatMenuHeader(header)}

      <div className="flat-menu__list-wrapper">
        {items.map(item => (
          <FlatMenuItem
            key={item.id}
            item={item}
            activeItem={activeItem}
            onItemSelect={onItemSelect}
            className={itemClassName}
            withRightArrow={withRightArrow}
          />
        ))}
      </div>
    </div>
  );
};

export default FlatMenu;
